import {combineReducers} from 'redux';
import servicesReducer from './services';
import blogReducer from './blogs';

export default combineReducers({
    services:servicesReducer,
    blogs:blogReducer
});